import React from 'react';
import { Link } from 'react-router-dom';

// Show correct "a/an" before the role ("an Educator", "a Scholar")
function article(role) {
  const r = String(role || '').toLowerCase();
  return r.startsWith('e') ? 'an' : 'a';
}

export default function RequestSubmitted({ role }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <img
          src="/icons/Propel_schools_logo.png"
          alt="Propel Schools"
          style={{ width: 200, height: 'auto', margin: '0 auto 12px', display:'block' }}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <h1 style={styles.h1}>Request Submitted</h1>
        <p style={styles.text}>
          Thanks! We’ve received your account request as {article(role)}{' '}
          <b style={{ color:'#003e73', textTransform:'capitalize' }}>{role}</b>.
          You’ll get an email when it’s approved.
        </p>

        {/* Button: centered text, updated label */}
        <Link to="/login" style={styles.primaryBtn}>
          <span>Return to Sign In</span>
        </Link>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight:'100vh', display:'grid', placeItems:'center', padding:24, background:'#F7F9FC' },
  card: { width: 480, maxWidth:'92vw', display:'grid', gap:12, background:'#fff', padding:24, borderRadius:16, boxShadow:'0 10px 24px rgba(0,0,0,0.08)' },
  h1: { margin: 0, fontSize: 24, color: '#003e73', textAlign: 'center' },
  text: { color: '#042d60', textAlign: 'center' },

  // This ensures the label is perfectly centered inside the yellow pill
  primaryBtn: {
    width: '100%',
    height: 48,
    borderRadius: 999,
    border: 'none',
    background: '#f9a21a',
    color: 'white',
    fontWeight: 900,
    marginTop: 12,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
